
  <div class="list-group panel"
       *ngIf="isAdmin">
    <a href="javascript:void(0)"
       class="list-group-item first">&nbsp;</a>
    <a href="#menu0"
       class="network list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Network Server Groups</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div *ngIf="isAdmin" class="collapse"
         id="menu0">
      <a href="#menu0sub1"
         [routerLink]="['/all-network-groups']"
         class="list-group-item transition item-sub sub-click network-server-groups"
         data-bs-parent="#menu0"
         data-bs-toggle="collapse"
         aria-expanded="false">List
      </a>
      <a href="javascript:void(0);"
         [routerLink]="['/create-ns-groups']"
         class="list-group-item transition item-sub"
         data-bs-parent="#menu0">Create
      </a>
    </div>
    <a href="#menu1"
       class="network list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Network Servers</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div class="collapse"
         id="menu1">
      <a href="#menu1sub1"
         [routerLink]="['/all-network']"
         class="list-group-item transition item-sub sub-click network-servers"
         data-bs-parent="#menu1"
         data-bs-toggle="collapse"
         aria-expanded="false">List
      </a>
      <a href="javascript:void(0);"
         [routerLink]="['/create-network-servers']"
         class="list-group-item transition item-sub"
         data-bs-parent="#menu1">Create
      </a>
    </div>
    <a href="#menu2"
       class="join list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Join Servers</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div class="collapse"
         id="menu2">
      <a href="#menu2sub1"
         [routerLink]="['/all-join']"
         class="list-group-item transition item-sub sub-clic join-servers"
         data-bs-parent="#menu2"
         data-bs-toggle="collapse"
         aria-expanded="false">List
      </a>
      <a href="javascript:void(0);"
         [routerLink]="['/create-join-servers']"
         class="list-group-item transition item-sub"
         data-bs-parent="#menu2">Create
      </a>
    </div>
    <a href="#menu4"
       class="join list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Communities</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div class="collapse"
         id="menu4">
      <a href="#menu4sub1"
         [routerLink]="['/all-roaming-community']"
         class="list-group-item transition item-sub sub-clic roaming-communities"
         data-bs-parent="#menu4"
         data-bs-toggle="collapse"
         aria-expanded="false">List
      </a>
      <a href="javascript:void(0);"
         [routerLink]="['/create-roaming-communities']"
         class="list-group-item transition item-sub"
         data-bs-parent="#menu4">Create
      </a>
    </div>
    <a href="#menu3"
       class="join list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Users</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div class="collapse"
         id="menu3">
      <a href="#menu3sub1"
         [routerLink]="['/admin-users']"
         class="list-group-item transition item-sub sub-clic"
         data-bs-parent="#menu3"
         data-bs-toggle="collapse"
         aria-expanded="false">List
      </a>
    </div>
    <a href="#menu5"
       class="join list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Visualization</span>
      <i class="fa fa-angle-left"
         aria-hidden="true">
      </i>
    </a>
    <div *ngIf="isAdmin" class="collapse"
         id="menu5">
      <a href="#menu5sub1"
         [routerLink]="['/roaming-agreement-peerings']"
         class="list-group-item transition item-sub sub-clic"
         data-bs-parent="#menu5"
         data-bs-toggle="collapse"
         aria-expanded="false">Roaming Agreements Matrix
      </a>
    </div>
  </div>

  <div class="list-group panel"
       *ngIf="!isAdmin">
    <a href="javascript:void(0)"
       class="list-group-item first">&nbsp;
    </a>
    <a href="#menu0" *ngIf="isAdmin"
       [routerLink]="['/all-network-groups']"
       class="network list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Network Server Groups</span>
    </a>
    <a href="#menu1"
       [routerLink]="['/all-network']"
       class="network list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Network Servers</span>
    </a>
    <a href="#menu2"
       [routerLink]="['/all-join']"
       class="join list-group-item collapsed"
       data-bs-toggle="collapse"
       aria-expanded="false">
      <span>Join Servers</span>
    </a>
  </div>
